<app-landing *ngIf="!isAuth && !isMobile"></app-landing>
<app-dashboard *ngIf="isAuth"></app-dashboard>
<app-mobile-landing *ngIf="isMobile"></app-mobile-landing>
